<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"
import { type AlertVariants, alertVariants } from "."

const props = defineProps<{
  class?: HTMLAttributes["class"]
  variant?: AlertVariants["variant"]
}>()
</script>

<template>
  <div role="alert" :class="cn(alertVariants({ variant }), props.class)">
    <slot name="icon" />

    <div class="min-w-0 flex-1 space-y-0.5">
      <slot />
    </div>
  </div>
</template>
